import { useQuery } from '@tanstack/react-query'
import { getJurisdictions } from 'api/wage/getJurisdictions'
import { wageJurisdictionKeys } from './keys'

export const useJurisdictionsQuery = () => {
  return useQuery({
    queryKey: wageJurisdictionKeys.list(),
    queryFn: () => getJurisdictions(),
  })
}
